/*
 * BrightLabs Proprietary Limited (c) 2021
 * https://www.brightlabs.co.bw
 * info@brightlabs.co.bw
 */

import React from "react";
import {Stack} from "@fluentui/react";
import Slide from 'react-reveal';

import hero from "../../images/illustrations/services_design.svg";

import Page from "../shared/Page";
import helpers from "../../k/helpers";
import Hero from "../shared/Hero";
import ServicePage from "../shared/ServicePage";


class HeroContent extends React.Component<any, any> {

    public render() {

        const
            padding = helpers.padding();

        return (
            <Stack tokens={{childrenGap: padding}}>

                <Stack>

                    <Slide left>
                        <Stack tokens={{childrenGap: -16}}>
                            <h4>
                                {helpers.links.services.text}
                            </h4>

                            <h1>
                                {helpers.links.design.text}
                            </h1>
                        </Stack>
                    </Slide>

                    <Slide right>
                        <h2>
                            Mockups and graphical designs<br />for your app.
                        </h2>
                    </Slide>

                </Stack>

                <Slide bottom>
                    <Stack verticalFill={true} verticalAlign={'center'} horizontalAlign={'center'}>
                        <h3>
                            Beautifully designed and user-friendly applications will help you stand out from the competition.
                            UX/UI design plays a significant role in the development process – take the usability of your app
                            to the next level with us. Our wide offer includes effective Event Storming workshops too.
                        </h3>
                    </Stack>
                </Slide>

            </Stack>
        );
    }
}

class AdditionalContent extends React.Component<any, any> {
    render() {
        return null;
    }
}

export default class ProductDesign extends ServicePage {

    public render() {

        const
            backgroundColor = 'rgba(0, 0, 0, 0.003)',
            backgroundSize = '25%',

            title = "BrightLabs | " + helpers.links.design.text,
            url = helpers.links.design.url,
            description = "Beautifully designed and user-friendly applications";

        return (
            <Page title={title} description={description} url={url}>

                <Hero backgroundColor={backgroundColor} backgroundSize={backgroundSize} hero={hero}>
                    <HeroContent />
                </Hero>

                <AdditionalContent />
            </Page>
        );
    }
}
